import { render, staticRenderFns } from "./search-tabs.vue?vue&type=template&id=3c7fa751&scoped=true&"
import script from "./search-tabs.vue?vue&type=script&lang=js&"
export * from "./search-tabs.vue?vue&type=script&lang=js&"
import style0 from "./search-tabs.vue?vue&type=style&index=0&id=3c7fa751&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7fa751",
  null
  
)

export default component.exports